import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import { Order, TOnSiteOrderType } from "src/app/types/orders/order";
import onSiteGridLPColumns from "./onSiteGridLPColumns";
import onSiteGridAffiColumns from "./onSiteGridAffiColumns";
import onSiteGridBoostColumns from "./onSiteGridBoostColumns";
import onSiteGridDiscColumns from "./onSiteGridDiscColumns";
import onSiteGridFillingColumns from "./onSiteGridFillingColumns";
import onSiteGridLeadColumns from "./onSiteGridLeadColumns";
import onSiteGridNLColumns from "./onSiteGridNLColumns";
import onSiteGridRankColumns from "./onSiteGridRankColumns";
import onSiteGridSellColumns from "./onSiteGridSellColumns";
import onSiteGridSiloColumns from "./onSiteGridSiloColumns";
import onSiteGridHistoryColumns from "./onSiteGridHistoryColumns";

export function useSiteAnalyzeOnSiteGridColumns(
    orderType: TOnSiteOrderType,
    action: (modal: "edit", data: Order) => void
): Array<SimpleEntityGridColumn> {
    const { formatMessage } = useIntl();

    switch (orderType) {
        case "LP":
            return onSiteGridLPColumns(formatMessage, action);
        case "NL":
            return onSiteGridNLColumns(formatMessage, action);
        case "FILLING":
            return onSiteGridFillingColumns(formatMessage, action);
        case "BOOST":
            return onSiteGridBoostColumns(formatMessage, action);
        case "SILO":
            return onSiteGridSiloColumns(formatMessage, action);
        case "SELL":
            return onSiteGridSellColumns(formatMessage, action);
        case "RANK":
            return onSiteGridRankColumns(formatMessage, action);
        case "LEAD":
            return onSiteGridLeadColumns(formatMessage, action);
        case "DISC":
            return onSiteGridDiscColumns(formatMessage, action);
        case "AFFI":
            return onSiteGridAffiColumns(formatMessage, action);
        case "HISTORY":
            return onSiteGridHistoryColumns(formatMessage);
    }

    return onSiteGridLPColumns(formatMessage, action);
}
